<template>
  <Popper placement="right">
    <div class="text-sm my-2" role="button">
      Zaplanuj komentarz
    </div>
    <template #content>
      <form @submit.prevent="addComment">
        <div style="width: 300px;">
          <input type="text" class="form-control" v-model="comment.Title" placeholder="Tytuł">
          <textarea class="form-control mr-3" v-model="comment.Content" placeholder="Treść" style="margin-top: 5px;"></textarea>

          <div class="text-sm mt-2 user-select-none">
            Kolor tekstu etykiety
            <div>
              <div
                @click="comment.TextColor = color"
                v-for="color in colors"
                :key="color"
                role="button"
                class="mx-1 px-1 d-inline border border-1"
                :class="{ 'border border-4': comment.TextColor === color }"
                :style="`background-color: ${color};`"
              ></div>
            </div>
          </div>
          <div class="text-sm mt-2 user-select-none" role="button">
            Kolor tła etykiety
            <div>
              <div
                @click="comment.BackgroundColor = color"
                v-for="color in colors"
                :key="color"
                role="button"
                class="mx-1 px-1 d-inline border border-1"
                :class="{ 'border border-4': comment.BackgroundColor === color }"
                :style="`background-color: ${color};`"
              ></div>
            </div>
          </div>

          <label :for="`${comment.id}-meeting-time`">Data w kalendarzu</label>

          <div>
            <input :id="`${comment.id}-meeting-time`" type="date" class="form-control" min="2018-06-07T00:00" v-model="comment.dateTime">
          </div>

          Wyślij przypomnienie:
          <input type="date" class="form-control" ref="selectedDate" v-model="comment.sendNotificationOn">
          Wypisz maile po przecinku:
          <input type="text" class="form-control" v-model="comment.mails" placeholder="Maile">

          <Popper placement="right" >
            <span role="button" class="btn btn-success mt-1">
              Wybierz maile z bazy
            </span>
            <template #content>
              <div v-for="m in mailings" :key="m.id" role="button" @click="AddMail (m.value)" style="width: 350px">
                {{ m.value }} -> {{ m.name }}
              </div>
            </template>
          </Popper>

          <div style="text-align: center;">
            <button class="btn btn-primary" style="margin-top: 5px; padding: 5px;" type="submit">
              Dodaj komentarz
            </button>
          </div>
        </div>
      </form>
    </template>
  </Popper>
</template>

<script>
import Popper from 'vue3-popper'
import Swal from 'sweetalert2'
import colors from '@/modules/cells/colors'
import emitter from '@/modules/events/emitter'
import { $axios } from '@/modules/http/axios'

export default {
  props: ['vehicle'],
  components: { Popper },
  data () {
    return {
      colors: colors,
      comment: {
        Title: '',
        Content: '',
        BackgroundColor: '#FFFFFF',
        TextColor: '#222222',
        mailsList: [],
        mails: '',
        sendNotificationOn: new Date().toISOString().split('T')[0],
        dateTime: new Date().toISOString().split('T')[0]
      }
    }
  },
  computed: {
    mailings () {
      return this.$store.getters.getCalendarMailings
    }
  },
  methods: {
    async addComment () {
      const mails = this.comment.mails.split(',')
      const postData = {
        Title: this.comment.Title,
        Content: this.comment.Content,
        TextColor: this.comment.TextColor,
        BackgroundColor: this.comment.BackgroundColor,
        MailNotificationRecipients: mails,
        sendNotificationOn: this.comment.sendNotificationOn,
        dateTime: this.comment.dateTime === '' ? new Date().toISOString().split('T')[0] : this.comment.dateTime
      }

      try {
        await $axios.post(`Comment/Vehicle/${this.vehicle.id}`, postData)
        emitter.emit('planCommentAdded')
        emitter.emit('trioCommentModified')
        this.makeEmptyComment()
        await Swal.fire('Dodano komentarz', '', 'success')
      } catch (e) {
        await Swal.fire(
          'Nie udało się dodać komentarza',
          `System nie był w stanie dodać komentarza <br> <span class="fw-bold">Kod błędu: ${e.response?.status}</span>`,
          'error'
        )
      }
    },

    handleNewLine (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },

    AddMail (mail) {
      this.comment.mails += mail + ','
    },

    makeEmptyComment () {
      this.comment = {
        Title: '',
        Content: '',
        BackgroundColor: '#FFFFFF',
        TextColor: '#222222',
        mailsList: [],
        mails: '',
        sendNotificationOn: new Date().toISOString().split('T')[0],
        dateTime: new Date().toISOString().split('T')[0]
      }
    }
  }
}
</script>
